import React, {Fragment} from 'react';
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {Card, Col, Row} from 'antd';
import {GUTTER_MD, MARGIN_MD, SPAN_HALF,} from '../../../styles/constants';
import MetadataSetTree from "./MetadataSetTree";
import MetadataSetDetailWrapper from "./MetadataSetDetailWrapper";
import ReportList from "../commons/ReportList";
import ReportDetailWrapper from "./ReportDetailWrapper";
import {getDbIdAnnotationFromAnnotations, METADATA_SET_ID_ANNOTATION_ID} from "../../../utils/referenceMetadata";
import {
  clearMetadataSetImportReports,
  createMetadataSetReport,
  deleteMetadataSetReport,
  downloadMetadataSetReport,
  hideMetadataSetReport,
  hideMetadataSetReportHtmlPage,
  readMetadataSetReport,
  setMetadataSetReportStep,
  showMetadataSetReportHtmlPage,
  submitMetadataSetImportReports,
  submitMetadataSetReport,
  submitMetadataSetReportClone,
  submitMetadataSetUpdateReportState,
  uploadMetadataSetImportReportsFile
} from "./actions";
import "./style.css"

const mapStateToProps = state => ({
  metadataSet: state.scenes.referenceMetadata.metadataSet.metadataSet,
  hasPermission: state.scenes.referenceMetadata.metadataSet.hasPermission,
  isReportVisible: state.scenes.referenceMetadata.metadataSet.isReportVisible,
  reports: state.scenes.referenceMetadata.metadataSet.reports,
  report: state.scenes.referenceMetadata.metadataSet.report,
  reportAnnotations: state.scenes.referenceMetadata.metadataSet.reportAnnotations,
  reportStructure: state.scenes.referenceMetadata.metadataSet.reportStructure,
  step: state.scenes.referenceMetadata.metadataSet.step,
  reportId: state.scenes.referenceMetadata.metadataSet.reportId,
  target: state.scenes.referenceMetadata.metadataSet.target,
  identifiableTargets: state.scenes.referenceMetadata.metadataSet.identifiableTargets,
  reportHtmlPageUrl: state.scenes.referenceMetadata.metadataSet.reportHtmlPageUrl,
  selectedAttribute: state.scenes.referenceMetadata.metadataSet.selectedAttribute,
  uploadedFileHash: state.scenes.referenceMetadata.metadataSet.uploadedFileHash,
  uploadedReports: state.scenes.referenceMetadata.metadataSet.uploadedReports,
  importedReports: state.scenes.referenceMetadata.metadataSet.importedReports
});

const mapDispatchToProps = dispatch => ({
  onReportCreate: () => dispatch(createMetadataSetReport()),
  onReportDelete: reportId => dispatch(deleteMetadataSetReport(reportId)),
  fetchReport: (metadataSetId, reportId, report) => dispatch(readMetadataSetReport(metadataSetId, reportId, report)),
  onReportHide: () => dispatch(hideMetadataSetReport()),
  onReportSubmit: (metadataSet, report, reportAnnotations, reportStructure, reportId, target, identifiableTargets, annotationsConfig, isDraft) =>
    dispatch(submitMetadataSetReport(metadataSet, report, reportAnnotations, reportStructure, reportId, target, identifiableTargets, annotationsConfig, isDraft)),
  onStepSet: (step, dataLanguages, t) => dispatch(setMetadataSetReportStep(step, dataLanguages, t)),
  onReportStateSubmit: (metadataSetId, reportId, newState) =>
    dispatch(submitMetadataSetUpdateReportState(metadataSetId, reportId, newState)),
  onHtmlPageShow: htmlPageUrl => dispatch(showMetadataSetReportHtmlPage(htmlPageUrl)),
  onHtmlPageHide: () => dispatch(hideMetadataSetReportHtmlPage()),
  onReportDownload: (metadataSetId, reportId, fileName, format) => dispatch(downloadMetadataSetReport(metadataSetId, reportId, fileName, format)),
  onReportCloneSubmit: (metadataSetId, reportId, newReportId) => dispatch(submitMetadataSetReportClone(metadataSetId, reportId, newReportId)),
  onImportReportsFileUpload: (metadataSetId, file) => dispatch(uploadMetadataSetImportReportsFile(metadataSetId, file)),
  onImportReportsClear: () => dispatch(clearMetadataSetImportReports()),
  onImportReportsSubmit: (metadataSetId, fileHash, reports) => dispatch(submitMetadataSetImportReports(metadataSetId, fileHash, reports))
});

const MetadataSet = ({
                       t,
                       hasPermission,
                       metadataSet,
                       reports,
                       report,
                       reportAnnotations,
                       isReportVisible,
                       reportStructure,
                       step,
                       reportId,
                       target,
                       identifiableTargets,
                       reportHtmlPageUrl,
                       selectedAttribute,
                       uploadedFileHash,
                       uploadedReports,
                       importedReports,
                       onReportCreate,
                       onReportDelete,
                       fetchReport,
                       onReportHide,
                       onReportSubmit,
                       onStepSet,
                       onReportStateSubmit,
                       onHtmlPageShow,
                       onHtmlPageHide,
                       onReportDownload,
                       onReportCloneSubmit,
                       onImportReportsFileUpload,
                       onImportReportsClear,
                       onImportReportsSubmit
                     }) =>
  <Fragment>
    <Row gutter={GUTTER_MD}>
      <Col span={SPAN_HALF}>
        <MetadataSetTree
          hasPermission={hasPermission}
        />
      </Col>
      <Col span={SPAN_HALF}>
        <MetadataSetDetailWrapper
          hasPermission={hasPermission}
        />
      </Col>
    </Row>
    {metadataSet && getDbIdAnnotationFromAnnotations(metadataSet, METADATA_SET_ID_ANNOTATION_ID) && (
      <Card
        title={t('scenes.referenceMetadata.commons.reportList.title')}
        type="inner"
        style={{marginTop: MARGIN_MD}}
      >
        <ReportList
          isDcat={false}
          ReportDetailWrapper={ReportDetailWrapper}
          msPermission={hasPermission}
          metadataSet={metadataSet}
          reports={reports}
          report={report}
          reportAnnotations={reportAnnotations}
          isReportVisible={isReportVisible}
          reportStructure={reportStructure}
          step={step}
          reportId={reportId}
          target={target}
          identifiableTargets={identifiableTargets}
          reportHtmlPageUrl={reportHtmlPageUrl}
          selectedAttribute={selectedAttribute}
          onReportCreate={onReportCreate}
          onReportDelete={onReportDelete}
          onReportShow={fetchReport}
          onReportHide={onReportHide}
          onReportSubmit={onReportSubmit}
          onStepSet={onStepSet}
          onReportStateSubmit={onReportStateSubmit}
          onHtmlPageShow={onHtmlPageShow}
          onHtmlPageHide={onHtmlPageHide}
          onReportDownload={onReportDownload}
          onReportCloneSubmit={onReportCloneSubmit}
          uploadedFileHash={uploadedFileHash}
          uploadedReports={uploadedReports}
          importedReports={importedReports}
          onReportsFileUpload={onImportReportsFileUpload}
          onReportsClear={onImportReportsClear}
          onReportsSubmit={onImportReportsSubmit}
        />
      </Card>
    )}
  </Fragment>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(MetadataSet);